import { EventEmitter, Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http, RequestOptions, URLSearchParams } from '@angular/http';
import { AuthenticationService } from 'app/core/index';

@Injectable()
export class StatisticsService {

    public $activeGame: EventEmitter<string> = new EventEmitter<string>();
    public _activeGame: string = 'all';

    /**
     * @param {Http} http
     */
    constructor(
        private http: Http,
    ) {
    }

    public todayTop() {
        return this.http.get('/api/history/today-top')
            .toPromise()
            .then(data => {
                return data.json();
            });
    }

    public getBiggestWinners(game: string) {
        return this.http.get(`/api/history/biggest-winnings/${ game }`);
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/games/services/statistics.service.ts